'use strict';

var button = {};

exports.__exports = button;
//# sourceMappingURL=button2.cjs.map
